module.exports = __webpack_public_path__ + "static/media/sms3.8ee745cc.svg";